import axios from "../lib/axios";

// Create a new leadership role
export const createLeadershipRole = async (data) => {
  try {
    const response = await axios.post("/leadership-role", data);
    return response.data;
  } catch (error) {
    throw new Error(
      error?.response?.data?.message || "Failed to create leadership role"
    );
  }
};

export const getLeadershipRole = async () => {
  try {
    const response = await axios.get("/leadership-role");
    return response.data;
  } catch (error) {
    throw new Error(
      error?.response?.data?.message || "Failed to create leadership role"
    );
  }
};

// Update an existing leadership role - Fixed to match backend route pattern
export const updateLeadershipRole = async (leadershipId, roleId, data) => {
  try {
    const response = await axios.put(
      `/leadership-role/${leadershipId}/role/${roleId}`,
      data
    );
    return response.data;
  } catch (error) {
    throw new Error(
      error?.response?.data?.message || "Failed to update leadership role"
    );
  }
};

export const deleteLeadershipRole = async (leadershipId, roleId) => {
  try {
    const response = await axios.delete(
      `/leadership-role/${leadershipId}/role/${roleId}`
    );
    return response.data;
  } catch (error) {
    throw new Error(
      error?.response?.data?.message || "Failed to delete leadership role"
    );
  }
};
